import script from "./ReturnPartialIpdBill.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnPartialIpdBill.vue?vue&type=script&setup=true&lang=js"

import "./ReturnPartialIpdBill.vue?vue&type=style&index=0&id=fdff4e04&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdff4e04"]])

export default __exports__